import { ModuloValutazioneRisposta } from ".";

export class ModuloValutazioneCompetenza {
    id!: string;
    testo!: string;
    info?: boolean;
    risposte!: Array<ModuloValutazioneRisposta>;
    risposta?: ModuloValutazioneRisposta;
    optional?: boolean;
}